const rootActionPath = 'core/BonusOffers300x250';

export const BONUS_OFFERS_300X250_VIEW = `${rootActionPath}/VIEW`;
